"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'slot.target.client': 'Cliente',
    'slot.target.coworker': 'Compañero',
    'slot.target.manager': 'Gerente',
    'slot.target.self': 'Yo',
};
